<template>
  <div class="web-003-home-column">
    <div
      :class="['title', canClick && 'can-click']"
      @click="onClickTitle"
    >
      {{ title }}
    </div>
  </div>
</template>

<script>
import { openUrl } from '../../../../../lib/utils';

export default {
    name: 'HomeColumnTitle',
    props: {
        title: {
            type: String,
            default: '',
        },
        catalogId: {
            type: [Number, String],
            default: '',
        },
        canClick: {
            type: Boolean,
            default: true,
        },
    },
    methods: {
        onClickTitle () {
            if (!this.canClick) return;
            const query = this.$route.query;
            const routeUrl = this.$router.resolve({
                path: '/webModulePage/articleList',
                query: {
                    catalogId: this.catalogId,
                    siteId: query.siteId,
                    from: 'home',
                },
            });
            openUrl(routeUrl.href);
        },
    },
};
</script>

<style scoped lang="scss">
.web-003-home-column {
    text-align: center;
    margin-bottom: 40px;
    .title {
        font-size: 32px;
        color: #464C5B;
        transition: width .4s;
        display: inline-flex;
        flex-direction: column;
        align-items: center;
        user-select: none;
        &.can-click {
            cursor: pointer;
        }
        &:after{
            content: '';
            display: block;
            width: 40%;
            height: 2px;
            max-width: 100%;
            margin-top: 3px;
            background: #2873E9;
            border-radius: 4px;
            transition: width .3s;
        }
        &:hover::after {
            width: 100%;
        }
    }
}
</style>
